import React, { createContext } from 'react';
/**
 * This context should eventually be moved back to the `/metaserver/` file space once the file viewer
 * has been decoupled from components injected in (example: toolbar, left/right nav, header, etc...).
 * This context is currently used inside of `/js` to provide access to the nested "preview content" component.
 */
// ** Sub region list **
// The implementation is added at run time in the modular app framework routing definition
// (example: metaserver/static/js/edison/ui/page/files_maf.routes.tsx)
export const FileViewerSubRegionContext = createContext({
    titleBarPassUi: null,
    previewContent: null,
    titlebarDropdowns: null,
    googleOneTap: null,
    toolbar: null,
    sidebarContent: null,
    mobileHeader: null,
    mobileActionBar: null,
    signUpBanner: null,
    titleBarRightSection: null,
    previewTour: null,
});
export const useFileViewerSubRegionContext = () => React.useContext(FileViewerSubRegionContext);
//# sourceMappingURL=file_viewer.context.preenvesnextjs.map
